import Subscription from './gen-subscription'
// import GraphQLError from './graphql-error'

export default {
  ...Subscription,
  // ...GraphQLError,
}

export * from './gen-subscription'
